<template>
  <div>
    <div class="row">
      <div class="col-12 mt-3">
        <Card body-classes="p-3" card-classes="shadow-sm">
          <template #header>
            <div class="d-flex flex-row align-items-center justify-content-between">
              <h5 class="mb-0 text-primary">
                <vue-feather type="trending-up" class="me-2"></vue-feather>
                Top Selling Categories - {{ store.name }}
              </h5>
              <div class="d-flex align-items-center gap-3">
                <div class="d-flex align-items-center">
                  <label for="fromDate" class="me-2 text-muted">From:</label>
                  <input type="date" id="fromDate" class="form-control form-control-sm" v-model="fromDate">
                </div>
                <div class="d-flex align-items-center">
                  <label for="toDate" class="me-2 text-muted">To:</label>
                  <input type="date" id="toDate" class="form-control form-control-sm" v-model="toDate">
                </div>
                <div class="d-flex align-items-center">
                  <label for="limit" class="me-2 text-muted">Top:</label>
                  <input type="number" id="limit" class="form-control form-control-sm" v-model="limit" min="5" max="50" style="width: 80px;">
                </div>
                <button class="btn btn-primary btn-sm" @click="getReport">
                  Generate Report
                </button>
              </div>
            </div>
          </template>
          <div>
            <div v-if="loading" class="text-center py-5">
              <Spinner spinner-class="mb-1" />
              <p class="text-muted mt-2">Loading top selling categories...</p>
            </div>
            <div v-else-if="reportData.length > 0">
              <div class="row mb-4">
                <div class="col-md-4">
                  <div class="card shadow-sm">
                    <div class="card-body text-center">
                      <vue-feather type="dollar-sign" size="24" class="text-success mb-2"></vue-feather>
                      <h6 class="text-muted mb-1">Total Revenue</h6>
                      <h4 class="mb-0 text-success">{{ formatNumber(totalRevenue) }}</h4>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="card shadow-sm">
                    <div class="card-body text-center">
                      <vue-feather type="package" size="24" class="text-primary mb-2"></vue-feather>
                      <h6 class="text-muted mb-1">Total Quantity Sold</h6>
                      <h4 class="mb-0 text-primary">{{ totalQuantity }}</h4>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="card shadow-sm">
                    <div class="card-body text-center">
                      <vue-feather type="grid" size="24" class="text-info mb-2"></vue-feather>
                      <h6 class="text-muted mb-1">Categories</h6>
                      <h4 class="mb-0 text-info">{{ reportData.length }}</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Category Name</th>
                      <th>Total Quantity Sold</th>
                      <th>Total Revenue</th>
                      <th>Product Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in reportData" :key="item.id">
                      <td>{{ index + 1 }}</td>
                      <td>
                        <strong>{{ item.name }}</strong>
                      </td>
                      <td>{{ item.total_quantity_sold + ' pcs' }}</td>
                      <td>{{ formatNumber(item.total_revenue) }}</td>
                      <td>{{ item.product_count }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else class="alert alert-info">
              <vue-feather type="info" size="18" class="me-2"></vue-feather>
              No data available for the selected period.
            </div>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import {decrypt} from "@/utils/crypto";
import analyticsService from "@/api/analyticsService";
import formatNumber from "@/utils/formatNumber";

export default {
  name: "TopSellingCategories",

  data(){
    return {
      profile: {},
      store: {},
      loading: false,
      fromDate: '',
      toDate: '',
      limit: 10,
      reportData: []
    }
  },

  methods: {
    formatNumber,
    async getReport() {
      if (!this.fromDate || !this.toDate) {
        return;
      }

      this.loading = true;
      try {
        const params = {
          store_id: this.store.id,
          from: this.fromDate,
          to: this.toDate,
          limit: this.limit
        };

        const response = await analyticsService.getTopSellingCategories(params);
        this.reportData = response || [];
      } catch(e) {
        console.error(e);
        this.reportData = [];
      } finally {
        this.loading = false;
      }
    },
    setDefaultDates() {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth();
      
      const firstDay = new Date(year, month, 1);
      const fromYear = firstDay.getFullYear();
      const fromMonth = String(firstDay.getMonth() + 1).padStart(2, '0');
      const fromDay = String(firstDay.getDate()).padStart(2, '0');
      
      const toYear = today.getFullYear();
      const toMonth = String(today.getMonth() + 1).padStart(2, '0');
      const toDay = String(today.getDate()).padStart(2, '0');

      this.fromDate = `${fromYear}-${fromMonth}-${fromDay}`;
      this.toDate = `${toYear}-${toMonth}-${toDay}`;
    }
  },

  computed: {
    totalRevenue() {
      return this.reportData.reduce((sum, item) => sum + parseFloat(item.total_revenue || 0), 0);
    },
    totalQuantity() {
      return this.reportData.reduce((sum, item) => sum + parseFloat(item.total_quantity_sold || 0), 0);
    }
  },

  created: async function () {
    this.profile = JSON.parse(decrypt(sessionStorage.getItem('profile')));
    this.store = JSON.parse(decrypt(sessionStorage.getItem('store')));
    this.setDefaultDates();
    await this.getReport();
  }
}
</script>

<style scoped>
.table th {
  background-color: #f8f9fa;
  font-weight: 600;
}
</style>
